export default __webpack_public_path__ + "static/media/Growth.50b2384a.png";